import { curry } from 'rich-text-lib/utils/iterables';
export const isUngated = (gateName, gates) => Array.isArray(gates) && gates.includes(gateName);
export const hasScope = (scope, scopes) => Array.isArray(scopes) && scopes.includes(scope);
export const withGatedPlugins = curry((gatedPlugins, plugins, gates) => gatedPlugins.reduce((accumulatePlugins, {
  gate,
  plugin
}) => [/* eslint-disable-next-line hubspot-dev/no-reduce-accumulator-copy */
...accumulatePlugins, ...(isUngated(gate, gates) ? [plugin] : [])], plugins));
export const getGated = curry((gatedPluginMap, gates) => {
  return Object.keys(gatedPluginMap).reduce((gated, gateKey) => {
    if (isUngated(gateKey, gates)) {
      const {
        plugin,
        flag
      } = gatedPluginMap[gateKey];
      if (plugin) {
        gated.plugins.push(plugin);
      }
      if (flag) {
        gated.flags[flag] = true;
      }
    }
    return gated;
  }, {
    plugins: [],
    flags: {}
  });
});